module.exports = __webpack_public_path__ + "img/doc.4eb83b6d.svg";